module.exports = __webpack_public_path__ + "img/icon_cursor.73402f1c.png";